// Kiwipoints del carrito en otra moneda (Jorge, 4-11-2026). En euros los pinta el servidor y aquí no se hace nada.
// El club suma siempre en euros y el tipo de cambio de Shopify solo está en el navegador, así que aquí se pasa el importe
// a euros. El carrito se vuelve a pintar entero al cambiar una cantidad, por eso se repasa con cada cambio en la página.
// Copia en el repo: .claude/theme-kw-cart-kp.js (assets/kw-cart-kp.js)
const c = window.Shopify && window.Shopify.currency;
const rate = c && c.active && c.active !== 'EUR' ? Number(c.rate) : 0;

function rellenar() {
  document.querySelectorAll('[data-kp-cents][hidden]').forEach((el) => {
    const n = el.querySelector('[data-kp-n]');
    if (!n) return;
    const puntos = Math.max(0, Math.floor((Number(el.dataset.kpCents) / 100 / rate) * Number(el.dataset.kpMult) + 1e-9));
    n.textContent = String(puntos);
    el.hidden = false;
  });
}

if (rate > 0) {
  rellenar();
  let pendiente = false;
  new MutationObserver(() => {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(() => {
      pendiente = false;
      rellenar();
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
}
